import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as storeActions from "../storeActions";
import * as recordService from "../../services/recordService";
import { handleApiError } from "../storeEffects";
import { RecordsAction, recordFailure, recordSuccess } from "./storeRecord";

//Effects
export type RecordThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, RecordsAction>

export const getRecordPage = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    dispatch(storeActions.fetchStart());
    return recordService.getRecordPage()
        .then(
            recordPage => {
                dispatch(recordSuccess(recordPage));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(recordFailure());
            })
        .finally(() =>
            dispatch(storeActions.fetchEnd())
        );
};